'use client'

import dynamic from 'next/dynamic'
import { Button, Typography } from '@mui/material'

// Types
import type { MenuButtonProps } from '@/types/components/atoms/buttons/menu'

// Components
const ExploreShapeAtom = dynamic(() => import('@/components/atoms/shapes/explore'))

const MenuButtonAtom = (props: MenuButtonProps) => {
	// Props
	const { selected, children } = props

	return (
		<Button
			variant="text"
			color="inherit"
			sx={{
				'& .MuiButton-icon': { zIndex: 1 },
				'& .brown-shape-atom': {
					width: 1,
					height: 1,
					position: 'absolute',
					color: 'primary.main',
					transition: 'all .3s ease'
				},
				'&:hover .brown-shape-atom': { color: 'primary.light' }
			}}
		>
			{selected && <ExploreShapeAtom />}

			<Typography component="span" fontSize={18} color="common.white" zIndex={1}>
				{children}
			</Typography>
		</Button>
	)
}

export default MenuButtonAtom
